import React, { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import Axios from "axios";

//COMPONENTS
import Controller from "./files/controller";
import LoginFailed from "./files/loginFailed";
import ProductDetails from "./files/productDetails";
import AccessModalInterface from "../../../../accessModal/files/frontInterface";
import Basket from "./files/basket/basket";
import BasketSideBar from "./files/basket/basketSideBar";
import Checkout from "./files/checkout/checkout";

import CancelPayment from "./files/checkout/cancelPayment";
import ProcessOrder from "./files/checkout/proccessOrder";
import OrderConfirmation from "./files/checkout/orderConfirmation";

import Footer from "./files/footer";

//ACTIONS
import * as AccessModalActions from "../../../../../envStore/actions/accessModal";
import * as PrintingShopActions from "../../../../../envStore/actions/3dPrintingShop";

function PodRouter() {
    const [isLoaded, setIsLoaded] = useState(false);
    const [footerText, setFooterText] = useState("");

    const user = useSelector((state) => state.user);
    const dispatch = useDispatch();

    useEffect(() => {
        const data = { end: "front" };
        Axios.post("/pods/3dPrintingShop/settings/load", data)
            .then((res) => {
                const data = res.data;
                console.log(data);
                if (data.error == "null") {
                    dispatch(PrintingShopActions.UpdateSettings(data.settings));
                    dispatch(PrintingShopActions.UpdateBottomFooterData(data.bottomFooterData));
                    setFooterText(data.settings.footerText);
                    if (user.requestedPassword) {
                        dispatch(AccessModalActions.UpdateScreen("changePassword"));
                    }
                    setIsLoaded(true);
                }
            })
            .catch((err) => console.log(err));
    });

    return (
        <div>
            {isLoaded && (
                <div>
                    <Row>
                        <Routes>
                            <Route path={"/"} element={<Controller />} />
                            <Route path={"/product/:code"} element={<ProductDetails />} />
                            <Route path={"/basket"} element={<Basket />} />
                            <Route path={"/checkout"} element={<Checkout />} />
                            <Route path={"/cancelPayment/:id"} element={<CancelPayment />} />
                            <Route path={"/processOrder"} element={<ProcessOrder />} />
                            <Route path={"/orderConfirmation"} element={<OrderConfirmation />} />
                            <Route path={"/passport-error"} element={<LoginFailed />} />
                        </Routes>
                        <AccessModalInterface />
                    </Row>
                    <Footer footerText={footerText} />
                </div>
            )}
        </div>
    );
}

export default PodRouter;
